import {OpenAIModel} from '../../openAI/openAI.enums';
import {OpenAIModelConfig} from '../../openAI/openAI.models';
import {LLMReasoningEffort, LLMVerbosity} from '../models.enums';

function getLLMModel(
  model: OpenAIModel,
  options?: Partial<Omit<OpenAIModelConfig, 'model'>>,
): OpenAIModelConfig {
  const modelDefaults: Record<OpenAIModel, OpenAIModelConfig> = {
    [OpenAIModel.Gpt4_1]: {
      model: OpenAIModel.Gpt4_1,
      temperature: 0 as const,
      reasoning_effort: undefined as never,
      verbosity: undefined as never,
    },
    [OpenAIModel.Gpt4_1Mini]: {
      model: OpenAIModel.Gpt4_1Mini,
      temperature: 0 as const,
      reasoning_effort: undefined as never,
      verbosity: undefined as never,
    },
    [OpenAIModel.Gpt5]: {
      model: OpenAIModel.Gpt5,
      temperature: 1 as const,
      reasoning_effort: LLMReasoningEffort.Minimal,
      verbosity: LLMVerbosity.Low,
    },
    [OpenAIModel.Gpt5Mini]: {
      model: OpenAIModel.Gpt5Mini,
      temperature: 1 as const,
      reasoning_effort: LLMReasoningEffort.Minimal,
      verbosity: LLMVerbosity.Low,
    },
    [OpenAIModel.Gpt5_1]: {
      model: OpenAIModel.Gpt5_1,
      temperature: 1 as const,
      reasoning_effort: LLMReasoningEffort.None,
      verbosity: LLMVerbosity.Low,
    },
    [OpenAIModel.Gpt5_2]: {
      model: OpenAIModel.Gpt5_2,
      temperature: 0 as const,
      reasoning_effort: LLMReasoningEffort.None,
      verbosity: LLMVerbosity.Low,
    },
  };

  return {
    ...modelDefaults[model],
    ...options,
  } as OpenAIModelConfig;
}

export default getLLMModel;
